import { useMemoOne } from 'use-memo-one';
import type { AxiosHookConfig } from 'src/hooks/use-axios';
import { useReauthenticate } from 'src/hooks/use-reauthenticate';
import { useToast } from 'src/hooks/use-toasts';
import { handleErrorWithNotification } from 'src/utils/handle-error';

export function useCustomAxiosConfig() {
  const notify = useToast();
  const [_, setReauthenticate] = useReauthenticate();

  const axiosHookConfig = useMemoOne<AxiosHookConfig>(
    () => ({
      onError(error, meta) {
        // let error boundary handle errors from eager requests: the very first request when flagged as neededOnPageLoad: true
        if (meta.isPageLoadError) throw error;

        handleErrorWithNotification({
          notify,
          error,
          setReauthenticate,
        });
      },
      cache: {},
    }),

    []
  );

  return axiosHookConfig;
}
